import React, { memo } from "react";
import CmsFormSkeleton from "./CmsFormSkeleton";

const PrivacyPolicySkeleton = memo(() => {
  return <CmsFormSkeleton />;
});

PrivacyPolicySkeleton.displayName = "PrivacyPolicySkeleton";

export default PrivacyPolicySkeleton;
